// extracted by mini-css-extract-plugin
export default {"box":"popupFollowAlert_box__8H1IZ","portfolioList":"popupFollowAlert_portfolioList__74Hlk"};